import { useSettingsStore } from "src/stores/settings";
import { ref } from "vue";

export function useRandomPalette() {
  const settingsStore = useSettingsStore();
  const lastSelectedPalette = ref(null);
  function getRandomPalette() {
    const palettes = settingsStore.colorPalettes;
    if (palettes.length > 0) {
      let selectedPalette;
      let attempts = 0;
      do {
        const randomIndex = Math.floor(Math.random() * palettes.length);
        selectedPalette = palettes[randomIndex];
        attempts++;
      } while (
        selectedPalette === lastSelectedPalette.value &&
        attempts < palettes.length
      );
      lastSelectedPalette.value = selectedPalette;
      // settingsStore.dark = isColorDark(selectedPalette.primary.hex);
      settingsStore.selectedPalette = selectedPalette;

      return selectedPalette;
    }
    return null;
  }
  return {
    getRandomPalette,
  };
}

export function isColorDark(hex) {
  const rgb = parseInt(hex.slice(1), 16);
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = (rgb >> 0) & 0xff;
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luminance < 128;
}
